module.exports = __webpack_public_path__ + "img/img9.ac70ba4b.png";